import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"order-receipt-header"},[_c('h1',[_vm._v(_vm._s(_vm.$t('order.receipt_title')))])]),_c('div',{staticClass:"order-receipt-content"},[_c(VIcon,{attrs:{"size":"150"}},[_vm._v(" mdi-receipt ")]),_c('br'),_c('h3',[_vm._v(_vm._s(_vm.$t('order.no_reciept')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }